import { DiagramDefinition } from "../types";

export const m013Definition: DiagramDefinition = {
  id: "M-013",
  title: "SSE Broadcast Topology",
  description:
    "Server-Sent Events (SSE) topic distribution topology where database mutations (Create/Update/Delete) trigger the Subscription Broker to filter events by channel and push updates to subscribed clients.",
  viewBox: "0 0 800 360",
  nodes: [
    { id: "A", kind: "database", label: "Record Created", subtext: "Insert Event", position: [100, 70], size: [130, 44] },
    { id: "C", kind: "database", label: "Record Updated", subtext: "Update Event", position: [100, 180], size: [130, 44] },
    { id: "D", kind: "database", label: "Record Deleted", subtext: "Delete Event", position: [100, 290], size: [130, 44] },

    { id: "B", kind: "service", label: "Subscription Broker", subtext: "Event Router", position: [320, 180], size: [160, 50], statusColor: "#ff5a1f" },
    { id: "E", kind: "service", label: "Channel Filters", subtext: "Topic Matcher", position: [520, 180], size: [140, 46] },

    { id: "F", kind: "client", label: "Client A", subtext: "channel: posts", position: [700, 80], size: [120, 42] },
    { id: "G", kind: "client", label: "Client B", subtext: "channel: posts", position: [700, 180], size: [120, 42] },
    { id: "H", kind: "client", label: "Client C", subtext: "channel: users", position: [700, 280], size: [120, 42] },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e2", source: "C", target: "B", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "D", target: "B", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e4", source: "B", target: "E", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e5", source: "E", target: "F", label: "posts", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e6", source: "E", target: "G", label: "posts", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e7", source: "E", target: "H", label: "users", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
  ],
};
